import { connect } from 'react-redux'

import { setAuthorized } from './reducer'

const mapStateToProps = (state) => {
    return {
        isAuthorized: state?.services?.auth?.isAuthorized,
    }
}

const hocAuth = (InnerComponent) => connect(mapStateToProps, { setAuthorized })(InnerComponent)

export default hocAuth
